import styled from 'styled-components'

import { theme } from '@/styles/theme'

import { DownloadLink } from '@/components/elements/DownloadLink'
import { Spacer } from '@/components/elements/Spacer'

import type { MediaKit } from '@/types/mediaKit'

type Props = {
  title: string
  mediaList: readonly MediaKit[]
}

export const Media = ({ title, mediaList }: Props) => {
  return (
    <div>
      <SectionTitle>{title}</SectionTitle>
      <Spacer h={{ sp: 30, pc: 50 }} />
      <List>
        {mediaList.map(({ _id, title, thumbnail, uploadFile }) => (
          <Item key={_id}>
            <Content>
              <img src={thumbnail.src} alt="" width="236" />
              <Title>{title}</Title>
            </Content>
            <DownloadLink fileType={uploadFile.fileType} url={uploadFile.src} />
          </Item>
        ))}
      </List>
    </div>
  )
}

const SectionTitle = styled.h4`
  font-size: 28px;
  font-weight: bold;
  letter-spacing: 1.68px;
  line-height: 42px;
  color: ${theme.colors.trialBlue};

  @media screen and (max-width: 1047px) {
    font-size: 20px;
    letter-spacing: 1.2px;
    line-height: 28px;
  }
`

const List = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, 236px);
  gap: 60px 32px;

  @media screen and (max-width: 1047px) {
    gap: 28px 22px;
    justify-content: center;
  }
`

const Item = styled.div`
  width: 236px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-self: stretch;
  gap: 20px;

  @media screen and (max-width: 1047px) {
    width: 100%;
    gap: 8px;
  }
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`

const Title = styled.div`
  font-size: 14px;
  letter-spacing: 1.4px;
  line-height: 20px;
  color: ${theme.colors.textTitle};
`
